import common from "./common.json";
import errors from "./errors.json";

export const es = {
    translation: common,
    error: errors,
};
